module.exports = __webpack_public_path__ + "img/02.c586c47e.png";